import React from 'react'
import {ReservationContext} from '../../../context/Reservation'
import {Modal} from '@material-ui/core'
import ReservationReserve from '../../ReservationReserve'

export const ReservationPop = () => {
  const {clearReservation, clearReservationsData} = React.useContext(ReservationContext)
  const [popReserve, setPopReserve] = React.useState(true)

  const handleClose = e => {
    setPopReserve(false)
    clearReservation()
    clearReservationsData()
  }

  const handleReserve = id => {
    setPopReserve(false)
    clearReservation()
  }
  return (
    // <Modal
    //   open={popReserve}
    //   onClose={handleClose}
    //   aria-labelledby="simple-modal-title"
    //   aria-describedby="simple-modal-description"
    // >
    <ReservationReserve fromGantt={false} handleClose={handleClose} handleReserve={handleReserve} />
    // </Modal>
  )
}
